define( function() {
	return ( /^\s+/ );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/manipulation/var/rleadingWhitespace.js
// module id = 44
// module chunks = 0